import axios from "axios";
import { getApiConfig } from "../config/api";

// Get API configuration for current environment
const apiConfig = getApiConfig();

// Configure axios defaults
axios.defaults.baseURL = apiConfig.baseURL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

// Add CORS credentials for cross-origin requests
axios.defaults.withCredentials = apiConfig.withCredentials;

// Set timeout
axios.defaults.timeout = apiConfig.timeout;

// Set up token from localStorage
const token = localStorage.getItem("access_token");
if (token) {
  axios.defaults.headers.common.Authorization = `Token ${token}`;
}

// Request interceptor to add token to requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 errors by clearing token and redirecting to login
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      delete axios.defaults.headers.common.Authorization;
      // Redirect to login page
      window.location.href = "/login";
    }
    
    // Handle network errors
    if (!error.response) {
      console.error("Network error - Backend may be unavailable");
    }
    
    return Promise.reject(error);
  }
);

export default axios;
